var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.orientation === '1')?_c('index'):_c('vertical')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }